import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Paper,
  IconButton,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import Swal from "sweetalert2";
import {
  createTestimonial,
  getTestimonial,
  updateTestimonial,
  deleteTestimonial,
} from "../../services/getAdminApi";

const CreateStudentTestimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [formData, setFormData] = useState({
    student_name: "",
    company_name: "",
    description: "",
    student_photo: null,
    company_logo: null,
  });
  const [save, setSave] = useState('SAVE')
  const [editingId, setEditingId] = useState(null);
  const [fileName, setFileName] = useState({
    student_photo: '',
    company_logo: '',
  });

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await getTestimonial();
   
      setTestimonials(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      Swal.fire("Error", "Failed to fetch testimonials", "error");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setFormData({
        ...formData,
        [name]: files[0],
      });
      setFileName({
        ...fileName,
        [name]: files[0].name, // Update the file name state when a file is selected
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSave = async () => {
    setSave('Saving...')
    if (!formData.student_name || !formData.company_name || !formData.description) {
      Swal.fire("Validation Error", "Please fill all required fields", "error");
      return;
    }

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value) payload.append(key, value);
    });

    try {
      if (editingId !== null) {
        const confirmEdit = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to update this testimonial?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, update it!",
        });

        if (confirmEdit.isConfirmed) {
         
             console.log("update", formData, editingId)
          let result = await updateTestimonial(editingId, formData).then((res)=>{
            console.log("MY res", res)
            if(res.status===200){
              Swal.fire("Success", "Testimonial updated successfully", "success");
            }
          }
          )
         
          
        }
      } else {
        await createTestimonial(payload).then((res)=>{
          console.log("MY res", res)
        if(res.status === 201){
          Swal.fire("Success", "Testimonial created successfully", "success");
          fetchTestimonials()
          setSave('SAVE')
        }
      }
      )
       
      }

      setFormData({
        student_name: "",
        company_name: "",
        description: "",
        student_photo: null,
        company_logo: null,
      });
      setFileName({
        student_photo: '',
        company_logo: '',
      });
      setEditingId(null);
      document.getElementById("file-upload").value = "";
      document.getElementById("company-logo").value = "";
      fetchTestimonials();
    } catch (error) {
      Swal.fire("Error", error, "error");
    }
    setSave('SAVE')
  };

  const handleEdit = (testimonial) => {
    Swal.fire({
      title: "Edit Testimonial",
      text: "Do you want to edit this testimonial?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, edit",
    }).then((result) => {
      if (result.isConfirmed) {
        setEditingId(testimonial.id);
        setFormData({
          student_name: testimonial.student_name,
          company_name: testimonial.company_name,
          description: testimonial.description,
          student_photo: null,
          company_logo: null,
        });
        setFileName({
          student_photo: testimonial.student_photo.slice(-10),
          company_logo: testimonial.company_logo.slice(-10),
        });
        fetchTestimonials()
      }
    });
  };

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "This action will delete the testimonial permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmDelete.isConfirmed) {
      try {
        await deleteTestimonial(id).then((res) => {
          if (res.status === 200) {
            Swal.fire("Success", "Testimonial deleted successfully", "success");
            fetchTestimonials();
          }
        })
      }
      catch (error) {
        Swal.fire("Error", "Failed to delete testimonial", "error");
      }


    }
  };

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Manage Students Testimonials</p>
      </div>

      <div className="editing-container">
        <div>
          <h2 className="editing-container-heading">
            {editingId !== null ? "Edit Testimonial" : "Create Testimonial"}
          </h2>

          <div className="editing-container-form">
            <div className="editing-container-input-div">
              <label>Student Name:</label>
              <input
                name="student_name"
                value={formData.student_name}
                onChange={handleInputChange}
                required
                placeholder="Enter Student Name"
              />
            </div>

            <div className="editing-container-input-div">
              <label>Company Name:</label>
              <input
                name="company_name"
                value={formData.company_name}
                onChange={handleInputChange}
                required
                placeholder="Enter Company Name"
              />
            </div>

            <div className="editing-container-input-div">
              <label>Description:</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
                placeholder="300 characters only"
                maxLength={300}

              />
            </div>

            <div className="editing-container-input-div">
              <label>Student Photo:</label>
              <label htmlFor="file-upload" className="file-upload-btn">
                <i className="bx bx-cloud-upload"></i> {fileName.student_photo || "Choose File"}
              </label>
              <input
                className="file-upload"
                id="file-upload"
                type="file"
                name="student_photo"
                accept="image/*"
                onChange={handleInputChange}
              />
            </div>

            <div className="editing-container-input-div">
              <label>Company Logo:</label>
              <label htmlFor="company-logo" className="file-upload-btn">
                <i className="bx bx-cloud-upload"></i> {fileName.company_logo || "Choose File"}
              </label>
              <input
                className="file-upload"
                id="company-logo"
                type="file"
                name="company_logo"
                accept="image/*"
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        <button variant="contained" color="primary" onClick={handleSave}>
          {editingId !== null ? "Update" : save} <i className="bx bx-send"></i>
        </button>
      </div>

      <div className="table-container-registered-students">
        <table>
          <thead>
            <tr>
              <th>Student Name</th>
              <th>Company Name</th>
              <th>Description</th>
              <th>Student Photo</th>
              <th>Company Logo</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {testimonials.map((testimonial) => (
              <tr key={testimonial.id}>
                <td>{testimonial.student_name}</td>
                <td>{testimonial.company_name}</td>
                <td>{testimonial.description}</td>
                <td>
                  {testimonial.student_photo && (
                    <img
                      src={`${"https://console.fbsedu.in/storage/app/"}/${testimonial.student_photo}`}
                      alt="Student Photo"
                      style={{ width: 50, height: 50 }}
                    />
                  )}
                </td>
                <td>
                  {testimonial.company_logo && (
                    <img
                      src={`${"https://console.fbsedu.in/storage/app/"}/${testimonial.company_logo}`}
                      alt="Company Logo"
                      style={{ width: 50, height: 50 }}
                    />
                  )}
                </td>
                <td>
                  <IconButton color="primary" onClick={() => handleEdit(testimonial)}>
                    <Edit />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(testimonial.id)}>
                    <Delete />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
};

export default CreateStudentTestimonial;
